
























































































































































import Vue from 'vue'
import { sic } from '@rhitics/core'
import { AssetsTableSelectors } from '../types/index'

export default Vue.extend({
  name: 'AssetsTableSelectors',
  data() {
    return {
      selectors: {
        verified: { label: '驗證狀態', loading: false, text: '請選擇驗證狀態' },
        batch: { label: '批次', loading: true, text: '請先上傳財編檔案' },
        keeperDepartment: { label: '保管部門', loading: false, text: '請先選擇批次' },
        keeper: { label: '保管人', loading: false, text: '請先選擇保管部門' }
      } as AssetsTableSelectors,
      verifiedOptions: [
        { text: '已驗證', value: true },
        { text: '未驗證', value: false },
        { text: '全選', value: 'all' }
      ],
      batchOptions: [] as Array<string>,
      keeperDepartmentOptions: [] as Array<string>,
      keeperOptions: [] as Array<string>,
      verifiedSelected: 'all' as boolean | 'all',
      batchSelected: '',
      keeperDepartmentSelected: [] as Array<string>,
      keeperSelected: [] as Array<string>
    }
  },
  computed: {
    selectAllDepartment(): boolean {
      return this.keeperDepartmentSelected.length === this.keeperDepartmentOptions.length
    },
    selectAllKeeper(): boolean {
      return this.keeperSelected.length === this.keeperOptions.length
    },
    selectSomeDepartment(): boolean {
      return this.keeperDepartmentSelected.length > 0 && !this.selectAllDepartment
    },
    selectSomeKeeper(): boolean {
      return this.keeperSelected.length > 0 && !this.selectAllKeeper
    },
    KeeperIcon() {
      if (this.selectAllKeeper) return 'far fa-check-square'
      if (this.selectSomeKeeper) return 'far fa-minus-square'
      return 'far fa-square'
    },
    DepartmentIcon() {
      if (this.selectAllDepartment) return 'far fa-check-square'
      if (this.selectSomeDepartment) return 'far fa-minus-square'
      return 'far fa-square'
    }
  },
  watch: {
    async verifiedSelected() {
      this.$emit('condition-update', {
        isVerified: this.verifiedSelected,
        batchs: [this.batchSelected],
        keeperDepartments: this.keeperDepartmentSelected,
        keepers: this.keeperSelected
      })
    },
    async batchSelected() {
      if (this.batchSelected === '') return
      this.$emit('condition-update', { isVerified: this.verifiedSelected, batchs: [this.batchSelected] })
      this.selectors.keeperDepartment.loading = true
      this.keeperDepartmentOptions = await this.getData({ batchs: [this.batchSelected], keeperDepartments: ['*'] })
      this.keeperDepartmentSelected = this.keeperDepartmentOptions
      this.selectors.keeperDepartment.loading = false
    },
    async keeperDepartmentSelected() {
      if (this.batchSelected === '' || this.keeperDepartmentSelected.length <= 0) return
      this.$emit('condition-update', {
        isVerified: this.verifiedSelected,
        batchs: [this.batchSelected],
        keeperDepartments: this.keeperDepartmentSelected
      })
      this.selectors.keeper.loading = true
      this.keeperOptions = await this.getData({
        batchs: [this.batchSelected],
        keeperDepartments: this.keeperDepartmentSelected
      })
      this.keeperSelected = this.keeperOptions
      this.selectors.keeper.loading = false
    },
    keeperSelected() {
      if (this.batchSelected === '' || this.keeperDepartmentSelected.length <= 0 || this.keeperSelected.length <= 0)
        return
      this.$emit('condition-update', {
        isVerified: this.verifiedSelected,
        batchs: [this.batchSelected],
        keeperDepartments: this.keeperDepartmentSelected,
        keepers: this.keeperSelected
      })
    }
  },
  async mounted() {
    this.init()
    this.batchOptions = await this.getData({ batchs: ['*'] })
    this.batchSelected = this.batchOptions[0]
    this.selectors.batch.loading = false
  },
  methods: {
    async init() {
      this.keeperDepartmentOptions, this.keeperOptions, this.keeperDepartmentSelected, (this.keeperSelected = [])
    },
    async getData(options: any) {
      return (await sic.asset.option(options)).data
    },
    toggleDepartment() {
      this.$nextTick(() => {
        if (this.selectAllDepartment) {
          this.keeperDepartmentSelected = []
        } else {
          this.keeperDepartmentSelected = this.keeperDepartmentOptions.slice()
        }
      })
    },
    toggleKeeper() {
      this.$nextTick(() => {
        if (this.selectAllKeeper) {
          this.keeperSelected = []
        } else {
          this.keeperSelected = this.keeperOptions.slice()
        }
      })
    }
  }
})
